import { Controller } from "@hotwired/stimulus"
import { savePlan } from "plan_storage"
import { renderIcons } from "lucide_icons"

// Current Services toolbar — toggles plan.meta.csShowServiceDescriptions
// which the print preview reads to decide whether to render the
// schedule/ratio sub-blocks beneath each service. Mirrors the toggle
// button at pcp_builder.html#5848.
const STORAGE_KEY = "pcp_plan_data"

export default class extends Controller {
  static targets = [ "descToggle", "descLabel" ]

  connect() {
    this._refresh()
  }

  toggleServiceDescriptions() {
    const plan = this._readPlan()
    if (!plan.meta) plan.meta = {}
    const next = !plan.meta.csShowServiceDescriptions
    plan.meta.csShowServiceDescriptions = next
    this._writePlan(plan)
    this._refresh()
  }

  _refresh() {
    const plan = this._readPlan()
    const on = !!plan?.meta?.csShowServiceDescriptions
    if (this.hasDescLabelTarget) {
      this.descLabelTarget.textContent =
        on ? "Service descriptions in Review/PDF: ON"
           : "Service descriptions in Review/PDF: OFF"
    }
    if (this.hasDescToggleTarget) {
      const icon = this.descToggleTarget.querySelector("i, svg")
      if (icon) icon.setAttribute("data-lucide", on ? "eye" : "eye-off")
    }
    renderIcons(this.element)
  }

  _readPlan() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {} }
    catch (_) { return {} }
  }
  _writePlan(plan) {
    savePlan(plan)
    document.dispatchEvent(new CustomEvent("plan-store:change"))
  }
}
